import { chatReducerConstant } from "../reducerConstant";

const initialState = {
  activeChatCount: 0,
};

const chatReducer = (state = initialState, action) => {
  switch (action.type) {
    case chatReducerConstant.GET_ACTIVE_CHAT_COUNT:
      return {
        ...state,
        activeChatCount: action.payload,
      };

    default:
      return state;
  }
};

export default chatReducer;
